export default "__VITE_ASSET__CXfQHzL3__"